import React, { useState } from "react";
import { footerData, submitNewsletterForm } from "../data/mock.js";
import andprlogo from "../asset/images/Logos/andprlogo.png";

const FOOTER_CSS = `
  .lux-footer {
    background: #000000;
    color: #ffffff;
    padding: 100px 0 40px;
    font-family: var(--font-body, system-ui, sans-serif);
  }
  .lux-footer-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-footer-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(247,230,202,0.15);
    padding-bottom: 60px;
    margin-bottom: 60px;
  }
  .lux-footer-newsletter-text h3 {
    font-size: 28px;
    font-weight: 300;
    margin: 0 0 8px;
    color: #fff;
    font-family: var(--font-heading, serif);
  }
  .lux-footer-newsletter-text p {
    font-size: 14px;
    color: rgba(255,255,255,0.55);
    margin: 0;
    max-width: 400px;
    line-height: 1.6;
  }

  .lux-footer-form {
    display: flex;
    gap: 12px;
    align-items: stretch;
  }

  .lux-footer-input {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.15);
    padding: 14px 20px;
    color: #fff;
    width: 240px;
    font-size: 13px;
    font-family: var(--font-body, system-ui, sans-serif);
    transition: all 0.3s ease;
    outline: none;
  } 

  .lux-footer-input:focus {
    border-color: #F7E6CA;
    background: rgba(255,255,255,0.06);
  }

  .lux-footer-input::placeholder {
    color: rgba(255,255,255,0.3);
  }

  .lux-footer-submit {
    background: #F7E6CA;
    color: #000;
    border: none;
    padding: 0 32px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s, color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lux-footer-submit:hover:not(:disabled) {
    background: #fff;
  }
  
  .lux-footer-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .lux-footer-success-box {
    background: rgba(247, 230, 202, 0.05);
    border: 1px solid rgba(247, 230, 202, 0.2);
    padding: 16px 20px;
    color: #F7E6CA;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: fadeIn 0.5s ease-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .lux-footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 40px;
    margin-bottom: 80px;
  }
    
  @media (max-width: 900px) {
    .lux-footer-top {
      flex-direction: column;
      align-items: flex-start;
      gap: 32px;
    }
    .lux-footer-form {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
    }
    .lux-footer-input {
      width: 100%;
    }
    .lux-footer-submit {
      padding: 16px 32px;
    }
    .lux-footer-grid {
      grid-template-columns: 1fr 1fr;
      row-gap: 60px;
    }
    .lux-footer-grid > div:first-child {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 600px) {
    .lux-footer-inner {
      padding: 0 24px;
    }
    .lux-footer-grid {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
      margin-bottom: 50px;
    }
    .lux-footer-grid > div:first-child {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .lux-footer-newsletter-text h3 {
      font-size: 24px;
    }
  }

  .lux-footer-brand {
    margin-bottom: 24px;
    display: inline-block;
  }
  /* Brand tagline — champagne tint on black */
  .lux-footer-desc {
    font-size: 13px;
    line-height: 1.8;
    color: rgba(247,230,202,0.55);
    max-width: 280px;
  }
  /* Column headings — champagne */
  .lux-footer-heading {
    font-size: 11px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #F7E6CA;
    margin-bottom: 24px;
    font-weight: 600;
  }
  .lux-footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .lux-footer-links li {
    margin-bottom: 12px;
  }
  /* Links — white at low opacity, hover to champagne */
  .lux-footer-links a {
    color: rgba(255,255,255,0.45);
    text-decoration: none;
    font-size: 13px;
    transition: color 0.3s;
    display: inline-block;
  }
  .lux-footer-links a:hover {
    color: #F7E6CA;
  }
  /* Bottom bar — champagne divider, white/champagne text */
  .lux-footer-bottom {
    border-top: 1px solid rgba(247,230,202,0.15);
    padding-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 11px;
    color: rgba(255,255,255,0.35);
    letter-spacing: 0.05em;
  }
  @media (max-width: 600px) {
    .lux-footer-bottom {
      flex-direction: column;
      gap: 16px;
      text-align: center;
    }
  }
`;

export default function Footer() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    ts: Date.now()
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSuccess, setIsSuccess] = useState(false);

  const handleLeadSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email) return;
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });
    try {
      const response = await submitNewsletterForm({
        ...formData
      });

      console.log("Submission success:", response);
      setIsSuccess(true);
      setStatus({ type: "success", message: "✓ You're on the list. Keep an eye on your inbox." });
      setFormData({ name: "", email: "", ts: Date.now() });

    } catch (error) {
      console.error("Submission Error:", error);
      setStatus({
        type: "error",
        message: error.message || "Something went wrong."
      });
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>{FOOTER_CSS}</style>
      <footer className="lux-footer">
        <div className="lux-footer-inner">

          {/* Lead Capture Form Section */}
          <div className="lux-footer-top">
            <div className="lux-footer-newsletter-text">
              <h3>Stay Connected</h3>
              <p>Subscribe to our newsletter for insights, strategy, and agency updates.</p>
            </div>

            {isSuccess ? (
              <div className="lux-footer-success-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 10 0 1 1 -5.93 -9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                {status.message}
              </div>
            ) : (
              <div style={{ width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <form className="lux-footer-form" onSubmit={handleLeadSubmit}>
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="lux-footer-input"
                    required
                    disabled={isSubmitting}
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="lux-footer-input"
                    required
                    disabled={isSubmitting}
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                  <button type="submit" className="lux-footer-submit" disabled={isSubmitting}>
                    {isSubmitting ? "Subscribing..." : "Subscribe"}
                  </button>
                </form>
                {status.message && status.type === 'error' && (
                  <div style={{ fontSize: '12px', color: '#ff4444', marginTop: '4px' }}>
                    {status.message}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="lux-footer-grid">
            {/* Brand */}
            <div>
              <a href="/" className="lux-footer-brand">
                <img
                  src={andprlogo}
                  alt="And PR Logo"
                  style={{ height: "45px", width: "auto", filter: "brightness(0) invert(1)" }}
                />
              </a>
              <p className="lux-footer-desc">
                {footerData?.brandTagline ||
                  "Digital experiences that drive growth — strategy, design, and development under one roof."}
              </p>
            </div>

            {/* Services */}
            <div>
              <div className="lux-footer-heading">Services</div>
              <ul className="lux-footer-links">
                <li><a href="/services">Our Expertise</a></li>
              </ul>
            </div>

            {/* Work */}
            <div>
              <div className="lux-footer-heading">Work</div>
              <ul className="lux-footer-links">
                <li><a href="/work">Case Studies</a></li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <div className="lux-footer-heading">Company</div>
              <ul className="lux-footer-links">
                <li><a href="/about">About</a></li>
                {/* <li><a href="/press">Press</a></li> */}
                <li><a href="/concierge">Contact</a></li>
              </ul>
            </div>

            {/* Social */}
            <div>
              <div className="lux-footer-heading">Social</div>
              <ul className="lux-footer-links">
                <li>
                  <a href="https://www.instagram.com/andpr.agency" target="_blank" rel="noopener noreferrer">
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/and-pr/" target="_blank" rel="noopener noreferrer">
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCKDQgWme-mMg74yDqeRt31g" target="_blank" rel="noopener noreferrer">
                    YouTube
                  </a>
                </li>
                <li>
                  <a href={`https://wa.me/${footerData?.whatsappNumber}`} target="_blank" rel="noopener noreferrer">
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="lux-footer-bottom">
            <span>{footerData?.copyright || "© 2026 And PR Agency. All Rights Reserved."}</span>
            <span>Made in New Delhi</span>
          </div>
        </div>
      </footer>
    </>
  );
}